<script>
    import { addDoc, collection, deleteDoc, doc, onSnapshot, orderBy, query, serverTimestamp, setDoc, updateDoc, where } from "firebase/firestore";
    import AddDevice from "../components/devices/AddDevice.svelte";
    import DevicesList from "../components/devices/DevicesList.svelte";
    import { db } from "../firebase/firestore";
    import { device_create, device_delete } from "../firebase/firebase";
    import { user, business } from "../firebase/auth";
    import LoadingOverlay from "../components/LoadingOverlay.svelte";

    const devicesRef = collection(db, "devices");
    const q = query(devicesRef, where("owner", "==", $user.uid), orderBy("created"))
    let devices = [];
    let loading = false;

    let unsub = onSnapshot(q, ((snap) => {
        devices = [];
        snap.forEach((doc) => {
            let device = doc.data();
            device.id = doc.id;
            devices.push(device);
        })
        devices = devices;
    }))

    async function add(e) {
        loading = true;
        try {
            await device_create({name: e.detail.name,  businessId: $business.id});
        } catch (error) {
            console.log(error);
        } finally {
            loading = false;
        }
    }

    async function remove(e) {
        loading = true;
        try {
            await device_delete({uid: e.detail.uid});
        } catch (error) {
            console.log(error);
        } finally {
            loading = false;
        }
    }

    function edit(e) {
        loading = true;
        let editRef = doc(db, "devices", e.detail.id);
        updateDoc(editRef, {
            ...e.detail,
        });
        loading = false;
    }
</script>


<h1>Geräte</h1>
<p>Du vergibst Stempel mit einem <b>Smartphone oder Tablet</b> und der Lokodil-App für Betriebe.</p>
<p>Um ein Smartphone oder Tablet hinzuzufügen klicke unten auf Gerät hinzufügen und <b>scanne</b> anschließend den <b>Login-QR-Code</b> mit deinem Gerät.</p>

<DevicesList bind:devices={devices} on:remove={remove} on:edit={edit} on:add={add}/>

{#if loading}
    <LoadingOverlay/>
{/if}